export enum GQLQueries {
  Nfts = 'Nfts',
  NFTItemScreen = 'NFTItemScreen',
  NftCollectionScreen = 'NftCollectionScreen',
  NftsTab = 'NftsTab',
  PortfolioBalances = 'PortfolioBalances',
  SelectWalletScreen = 'SelectWalletScreen',
  TransactionHistoryUpdater = 'TransactionHistoryUpdater',
  Token = 'Token',
  TokenDetailsScreen = 'TokenDetailsScreen',
  TokenPriceHistory = 'TokenPriceHistory',
  // TokenProjects = 'TokenProjects', // 🚨 已禁用：后端服务不支持此接口
  TransactionList = 'TransactionList',
  FeedTransactionList = 'FeedTransactionList',
  TopTokens = 'TopTokens',
  SearchTokens = 'SearchTokens',
  ExploreSearch = 'ExploreSearch',
  SpotPrices = 'SpotPrices',
  ExploreTokensTab = 'ExploreTokensTab',
  FavoriteTokenCard = 'FavoriteTokenCard',
}
